<nav compact tuiSubheader [style.position]="'sticky'" class="bg-white">
    <tui-breadcrumbs [itemsLimit]="10">
        <ng-container *ngFor="let item of breadcrumbs; let last = last; let i = index">
            <ng-container *ngIf="last">
                <strong *tuiItem tuiFade>
                    {{ item }}
                </strong>
            </ng-container>
            <ng-container *ngIf="!last">
                <button *tuiItem tuiLink type="button" (click)="navigateTo(i)">
                    {{ item }}
                </button>
            </ng-container>
        </ng-container>
    </tui-breadcrumbs>
</nav>

<section>
    <div class="flex flex-col mt-10 lg:mt-10 xl:mt-16 lg:mx-10 xl:mx-16">
        <div class="flex justify-between items-center">
            <div class="w-[268px] h-[84px]">
                <img src="/assets/logo.png" class="w-full h-full object-contain" alt="Royal Hospital Logo">
            </div>
            <div class="flex flex-col items-center justify-center">
                <p class="font-semibold text-[1.75rem] text-[#285CA5] py-2 m-0">Home Nursing Care</p>
                <p class="font-semibold text-[2rem] text-[#212429] py-2 m-0 p-0 text-center">Royal Hospital (Pvt) Ltd 
                </p>
                <p class="font-normal text-base text-[#212429] py-2 m-0 text-center">No. 62, W.A.Silva Mawatha, Wellawatta, Colombo - 06  |
                    Hot Line
                    0117 999 449</p>
            </div>
            <div class="w-[268px] h-[84px] md:hidden lg:hidden xl:block 2xl:block">

            </div>
        </div>
        <div class="w-full bg-[#D9D9D9] h-[1px] mt-8 mb-3"></div>
        <div class="flex justify-between">
            <div>

                <div class="flex items-start space-x-20">
                    <p class="text-base font-medium text-[#5B5B5B] my-[5px]">Invoice Number</p>
                    <p class="text-base font-medium text-[#353A3F] my-[5px]">{{ invoiceNumberDisplay }}</p>
                </div>
                <div class="flex items-start space-x-[5.7rem]">
                    <p class="text-base font-medium text-[#5B5B5B] my-[5px]">Client Reg No.</p>
                    <p class="text-base font-medium text-[#353A3F] my-[5px]">{{ invoiceClientRefDisplay }}</p>
                </div>
                <div class="flex items-start space-x-[6.6rem]">
                    <p class="text-base font-medium text-[#5B5B5B] my-[5px]">Patient Name</p>
                    <p class="text-base font-medium text-[#353A3F] my-[5px]">{{ invoice?.clientId?.name }}</p>
                </div>
                <div class="flex items-start space-x-[8.6rem]">
                    <p class="text-base font-medium text-[#5B5B5B] my-[5px]">Address</p>
                    <p class="text-base font-medium text-[#353A3F] my-[5px]">{{ invoice?.clientId?.guardianAddress }}</p>
                </div>
                <div class="flex items-start space-x-[7.1rem]">
                    <p class="text-base font-medium text-[#5B5B5B] my-[5px]">Contact No </p>
                    <p class="text-base font-medium text-[#353A3F] my-[5px]">{{ invoice?.clientId?.guardianContactNo }}</p>
                </div>

            </div>

            <div>
                <div class="flex items-start space-x-[11.4rem]">
                    <p class="text-base font-medium text-[#5B5B5B] my-[5px]">Date</p>
                    <p class="text-base font-medium text-[#353A3F] my-[5px]">{{ invoice?.createdAt | date: 'MM/dd/yyyy' }}</p>
                </div>
                <div class="flex items-start space-x-[6.4rem]">
                    <p class="text-base font-medium text-[#5B5B5B] my-[5px]">Admission Date</p>
                    <p class="text-base font-medium text-[#353A3F] my-[5px]">{{ invoice?.admissionDate | date: 'MM/dd/yyyy' }}</p>
                </div>
                <div class="flex items-start space-x-[8.3rem]">
                    <p class="text-base font-medium text-[#5B5B5B] my-[5px]">Billing Date</p>
                    <p class="text-base font-medium text-[#353A3F] my-[5px]"> {{ billingDate | date: 'MM/dd/yyyy' }}</p>
                </div>
            </div>

        </div>
        <div class="w-full bg-[#D9D9D9] h-[1px] my-3"></div>
        <div class="mt-8">

            <table tuiTable size="m" class="w-[50rem] md:w-[42rem] lg:w-[52rem] xl:w-[71rem] 2xl:w-[105rem]">
                <thead>
                    <tr>
                        <th tuiTh style="background-color: #F9FBFF;">Description </th>
                        <th tuiTh style="background-color: #F9FBFF; text-align: end;">Qyt</th>
                        <th tuiTh style="background-color: #F9FBFF; display: flex; justify-content: end; align-items: center;">Unit Price</th>
                        <th tuiTh style="background-color: #F9FBFF; text-align: end;">Total</th>
                    </tr>
                </thead>

                <tbody tuiTbody>
                    <tr *ngFor="let charge of invoice?.charges">
                        <td tuiTd style="padding-top: 0px;padding-bottom: 0px;">
                            <div tuiCell="m">
                                <p class="text-[#526ED3] text-sm">{{ charge.description }}</p>
                            </div>
                        </td>
                        <td tuiTd style="padding-top: 0px;padding-bottom: 0px;">
                            <div tuiCell="m" class="flex justify-end">
                                <p class="text-[#191C30E5] text-sm">{{ charge.quantity }}</p>
                            </div>
                        </td>
                        <!-- unit price -->
                        <td tuiTd style="padding-top: 0px;padding-bottom: 0px;">
                            <div tuiCell="m" class="flex justify-end">
                                <p class="text-[#191C30E5] text-sm text-right">LKR {{ charge.unitPrice | number:'1.2-2' }}</p>
                            </div>
                        </td>
                        <!-- total -->
                        <td tuiTd style="padding-top: 0px;padding-bottom: 0px;">
                            <div tuiCell="m" class="flex justify-end">
                                <p class="text-[#191C30E5] text-sm text-right">LKR {{ charge.quantity * charge.unitPrice | number:'1.2-2' }}</p>
                            </div>
                        </td>
                    </tr>
                </tbody>

            </table>

        </div>
        <div class="w-full flex justify-end mt-3">
            <div class="flex w-full max-w-xl items-center justify-end gap-x-10">
                <div class="min-w-0 flex-1 flex flex-col gap-1 text-left">
                    <p class="text-base font-bold text-[#2a2a2a] my-0">Sub Total</p>
                    <p class="text-base font-bold text-[#2a2a2a] my-0">Amount to be Paid</p>
                </div>
                <p class="text-right text-base font-bold text-[#2a2a2a] tabular-nums whitespace-nowrap shrink-0 my-0">
                    LKR {{ invoice?.amount | number : '1.2-2' }}
                </p>
            </div>
        </div>
        <div class="w-full bg-[#D9D9D9] h-[1px] my-8"></div>
        <div class="flex space-x-28">
            <div>
                <p class="text-base font-medium text-[#5B5B5B] my-[5px]">Account Details</p>
            </div>
            <div>
                <p class="text-base font-medium text-[#353A3F] my-[5px] ">Royal Hospital Home Nursing (pvt) ltd <br>
                    Commercial Bank 1000650035 <br>
                    Wellawatta 02nd Branch <br>
                    Swift Code CCEYLKLX</p>
            </div>
        </div>
    </div>
</section>